module.exports = __webpack_public_path__ + "img/imghuanxhy-wxz.034fa707.png";